import { render, staticRenderFns } from "./ListContentLoader.vue?vue&type=template&id=586f3e5c&scoped=true&"
import script from "./ListContentLoader.vue?vue&type=script&lang=js&"
export * from "./ListContentLoader.vue?vue&type=script&lang=js&"
import style0 from "./ListContentLoader.vue?vue&type=style&index=0&id=586f3e5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586f3e5c",
  null
  
)

export default component.exports